import NotificationAlert from 'componentes/generic/Notification.js';
import { useAuth } from 'context/AuthProvider.js';
import { ApiEndpoint } from 'helpers/ApiEndPoint.js';
import { httpClient } from 'helpers/HttpClient.js';
import React, { useEffect, useState } from 'react';
import { Button, Card, Col, Form, FormControl, Row } from 'react-bootstrap';
import { useForm } from 'react-hook-form';
import PropTypes from 'prop-types';
import Divider from 'componentes/common/Divider.js';
const URI = ApiEndpoint + 'account/';
const EditUser = ({ idUser, closeModal }) => {
  const Auth = useAuth();
  var userData = Auth.getSessionData();
  const [roles, setRoles] = useState(null);
  const [selectedRol, setSelectedRol] = useState(null);
  const [showErrorMessage, setShowErrorMessage] = useState(false);
  const [errorMesagge, setErrorMesagge] = useState(null);

  const [user, setUser] = useState({
    nombre: '',
    usuario: '',
    apellidomaterno: '',
    apellidopaterno: '',
    password: '',
    confirmPassword: '',
    idrol: ''
  });

  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors }
  } = useForm();

  const getRolesList = async () => {
    setRoles(null);

    httpClient('GET', URI + 'roles', {}, userData.token)
      .then(function (response) {
        if (!response.data.error) {
          setRoles(response.data);
        }
      })
      .catch(function (error) {
        console.log(error);
      });
  };
  const getUser = async () => {
    setUser(null);

    httpClient('GET', URI + 'user/' + idUser, {}, userData.token)
      .then(function (response) {
        if (!response.data.error) {
          console.log(response.data);
          setUser(response.data);
          setSelectedRol(response.data.idrol);
          setValue('nombre', response.data.nombre);
          setValue('usuario', response.data.usuario);
          setValue('apellidopaterno', response.data.apellidopaterno);
          setValue('apellidomaterno', response.data.apellidomaterno);
          setValue('idrol', response.data.idrol);
        }
      })
      .catch(function (error) {
        console.log(error);
      });
  };
  useEffect(() => {
    console.log(idUser);
    if (idUser > 0) getUser();
    getRolesList();
  }, []);

  const onSubmit = data => {
    console.log(data);
    if (idUser == 0) {
      if (data.password != data.confirmPassword) {
        setErrorMesagge('Las contraseñas no coinciden');
        setShowErrorMessage(true);
        return;
      }
      var formatregex =
        /^(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])(?=.*\W)(?!.* ).{6,16}$/;
      if (!formatregex.test(data.password)) {
        setErrorMesagge('La contraseña no contiene un formato valido');
        setShowErrorMessage(true);
        return;
      }
    }

    if (idUser > 0) {
      httpClient(
        'put',
        URI + 'user/' + idUser,
        {
          usuario: data.usuario,
          idrol: data.idrol,
          nombre: data.nombre,
          apellidomaterno: data.apellidomaterno,
          apellidopaterno: data.apellidopaterno
        },
        userData.token
      )
        .then(function (response) {
          if (!response.data.error) {
            closeModal();
          }
        })
        .catch(function (error) {
          console.log(error);
        })
        .finally(() => {});
    } else {
      httpClient(
        'POST',
        URI + 'user',
        {
          usuario: data.usuario,
          idrol: data.idrol,
          nombre: data.nombre,
          apellidomaterno: data.apellidomaterno,
          apellidopaterno: data.apellidopaterno,
          password: data.password
        },
        userData.token
      )
        .then(function (response) {
          if (!response.data.error) {
            closeModal();
          } else {
            setErrorMesagge(response.data.message);
            setShowErrorMessage(true);
          }
        })
        .catch(function (error) {
          console.log(error);
        })
        .finally(() => {});
    }
  };
  return (
    <>
      <Card style={{ width: '100%' }}>
        <Card.Body>
          <Form onSubmit={handleSubmit(onSubmit)}>
            <Row>
              <Col>
                <Form.Group className="mb-4">
                  <Form.Label>Nombre</Form.Label>
                  <FormControl
                    {...register('nombre', {
                      required: 'El Nombre es requerido',
                      minLength: {
                        value: 3,
                        message: 'El Nombre debe tener al menos 4 caracteres'
                      },
                      maxLength: {
                        value: 30,
                        message: 'El Nombre debe tener máximo 30 caracteres'
                      }
                    })}
                    type="text"
                    defaultValue={user?.nombre}
                    isInvalid={!!errors.nombre}
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors.nombre?.message}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col>
                <Form.Group className="mb-4">
                  <Form.Label>Apellido Paterno</Form.Label>
                  <FormControl
                    {...register('apellidopaterno', {
                      required: 'El Apellido Paterno es requerido',
                      minLength: {
                        value: 3,
                        message:
                          'El Apellido Paterno debe tener al menos 4 caracteres'
                      },
                      maxLength: {
                        value: 30,
                        message:
                          'Apellido Paterno debe tener máximo 30 caracteres'
                      }
                    })}
                    type="text"
                    defaultValue={user?.apellidopaterno}
                    isInvalid={!!errors.apellidopaterno}
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors.apellidopaterno?.message}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col>
                <Form.Group className="mb-4">
                  <Form.Label>Apellido Materno</Form.Label>
                  <FormControl
                    {...register('apellidomaterno', {
                      required: 'El Apellido Materno es requerido',
                      minLength: {
                        value: 3,
                        message:
                          'El Apellido Materno debe tener al menos 4 caracteres'
                      },
                      maxLength: {
                        value: 30,
                        message:
                          'Apellido Materno debe tener máximo 30 caracteres'
                      }
                    })}
                    type="text"
                    defaultValue={user?.apellidomaterno}
                    isInvalid={!!errors.apellidomaterno}
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors.apellidomaterno?.message}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col>
                <Form.Group className="mb-4">
                  <Form.Label>Rol Asignado</Form.Label>
                  <select
                    aria-label="Default select"
                    name="idrol"
                    id="idrol"
                    className="form-control"
                    {...register('idrol', {
                      required: 'Campo Requerido'
                    })}
                    onChange={e => {
                      setValue('idrol', e.target.value, {
                        shouldValidate: true
                      });
                      setSelectedRol(e.target.value);
                    }}
                    value={`${selectedRol}`}
                    style={{ minWidth: '250px' }}
                  >
                    <option key={'location_0'} value="">
                      Selecciona un Rol
                    </option>
                    {!!roles?.length &&
                      roles.map(rol => (
                        <option key={rol.idrol} value={rol.idrol}>
                          {rol.rol}
                        </option>
                      ))}
                  </select>
                  <Form.Control.Feedback type="invalid">
                    {errors.idrol?.message}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col>
                <Form.Group className="mb-4">
                  <Form.Label>Usuario</Form.Label>
                  <FormControl
                    {...register('usuario', {
                      required: 'El Usuario es requerido',
                      minLength: {
                        value: 3,
                        message: 'El Usuario debe tener al menos 4 caracteres'
                      },
                      maxLength: {
                        value: 30,
                        message: 'El Usuario debe tener máximo 30 caracteres'
                      }
                    })}
                    type="text"
                    defaultValue={user?.usuario}
                    isInvalid={!!errors.usuario}
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors.usuario?.message}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
            </Row>
            <Divider />
            {idUser == 0 && (
              <>
                {' '}
                <Row>
                  <Col>
                    <Form.Group className="mb-4">
                      <Form.Label>Contraseña</Form.Label>
                      <h5
                        style={{
                          marginTop: '0px',
                          marginBottom: '10px',
                          borderRadius: '5px',
                          padding: '5px',
                          background: '#6d757d',
                          color: '#fff',
                          width: 'fit-content',
                          fontWeight: '400',
                          fontSize: '12px'
                        }}
                      >
                        La contraseña debe tener una longitud minima de 6
                        caracteres y al menos debe contener al menos un numero,
                        una letra minuscula, una letra mayuscula, y un caracter
                        especial
                      </h5>
                      <FormControl
                        {...register('password')}
                        type="password"
                        defaultValue={user?.password}
                        isInvalid={!!errors.password}
                      />
                      <Form.Control.Feedback type="invalid">
                        {errors.password?.message}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group className="mb-4">
                      <Form.Label>Confirmar Contraseña</Form.Label>
                      <FormControl
                        {...register('confirmPassword')}
                        type="password"
                        defaultValue={user?.confirmPassword}
                        isInvalid={!!errors.confirmPassword}
                      />
                      <Form.Control.Feedback type="invalid">
                        {errors.confirmPassword?.message}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>
                </Row>
              </>
            )}
            <Row>
              <Col>
                <Button type="submit" color="primary" size="sm">
                  Guardar
                </Button>
              </Col>
            </Row>
          </Form>
        </Card.Body>
      </Card>
      <NotificationAlert
        message={errorMesagge}
        showNotification={showErrorMessage}
        setShowNotification={setShowErrorMessage}
      />
    </>
  );
};
EditUser.propTypes = {
  idUser: PropTypes.number.isRequired,
  closeModal: PropTypes.func
};
export default EditUser;
